'use client';

import {
  AppPalettes,
  DiscCDPalettes,
  DiscCPalettes,
  DiscDIPalettes,
  DiscDPalettes,
  DiscIPalettes,
  DiscISPalettes,
  DiscSCPalettes,
  DiscSPalettes,
} from '@prismo-io/design-system';
import { ThemeProvider } from '@prismo-io/design-system/theme-provider';
import { AuraProfileCode, type AuraProfileCodeT } from '@prismo-io/schemas';
import { type FC, type PropsWithChildren, useMemo } from 'react';

type Props = {
  auraProfileId?: AuraProfileCodeT | null;
};

export const AuraProfileTheme: FC<PropsWithChildren<Props>> = (props) => {
  const { children, auraProfileId = null } = props;

  const theme = useMemo(() => {
    switch (auraProfileId) {
      case AuraProfileCode.Enum.ADVISOR:
        return DiscSPalettes.light;
      case AuraProfileCode.Enum.ANALYST:
        return DiscCPalettes.light;
      case AuraProfileCode.Enum.ANIMATOR:
        return DiscIPalettes.light;
      case AuraProfileCode.Enum.COACH:
        return DiscDIPalettes.light;
      case AuraProfileCode.Enum.PEACEMAKER:
        return DiscISPalettes.light;
      case AuraProfileCode.Enum.PILOT:
        return DiscDPalettes.light;
      case AuraProfileCode.Enum.PLANNER:
        return DiscCDPalettes.light;
      case AuraProfileCode.Enum.PROTECTOR:
        return DiscSCPalettes.light;
      default:
        return AppPalettes.light;
    }
  }, [auraProfileId]);

  return (
    <ThemeProvider theme={theme} options={{ key: 'aura-profile-theme' }}>
      {children}
    </ThemeProvider>
  );
};
